import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

export default function DashboardStatCard({ icon, subtitle, title, value }) {
  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="subtitle2" color="text.secondary">
          {title}
        </Typography>
        <Box sx={{ color: 'primary.main' }}>
          {icon}
        </Box>
      </Box>
      <Typography variant="h4" sx={{ lineHeight: 1.1 }}>
        {value}
      </Typography>
      {subtitle ? (
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      ) : null}
    </Paper>
  );
}
